import filterPlateTypeCheckers from '../../../../../../types/filterPlateTypeCheckers';

const usesFieldInPlates = (
  plates: FilterPlateType[] | undefined,
  field: string,
  dataset: string,
) => {
  if (!plates) return false;
  return plates.some((p) => {
    if (filterPlateTypeCheckers.isFixed(p)) {
      return p.fixedValue.field === field && p.fixedValue.dataset === dataset;
    }
    return false;
  });
};

export default usesFieldInPlates;
